import { render, staticRenderFns } from "./PaymentResponse.vue?vue&type=template&id=423525d7&scoped=true&"
import script from "./PaymentResponse.vue?vue&type=script&lang=ts&"
export * from "./PaymentResponse.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentResponse.vue?vue&type=style&index=0&id=423525d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423525d7",
  null
  
)

export default component.exports